<p-dropdown
  [options]="dropdownOptions()"
  [ngModel]="value"
  (onChange)="onValueChange($event.value)"
  (onShow)="dropdownShow.emit()"
  optionLabel="label"
  [filter]="enableFilter()"
  filterBy="label"
  [showClear]="true"
  [placeholder]="placeholder()"
  appendTo="body"
  [panelStyleClass]="panelStyleClass()"
  [class]="class()"
>
  <ng-template pTemplate="selectedItem" let-selectedOption>
    <div class="flex-container">
      <span [pTooltip]="selectedOption?.label" tooltipPosition="right">{{
        selectedOption?.label
      }}</span>
      @if (selectedOption?.version) {
      <span [pTooltip]="selectedOption?.version" tooltipPosition="right">{{
        selectedOption?.version
      }}</span>
      }
    </div>
  </ng-template>
  <ng-template let-option pTemplate="item">
    <div class="flex-container">
      <span [pTooltip]="option?.label" tooltipPosition="right">{{
        option.label
      }}</span>
      @if (option?.version) {
      <span>{{ option?.version }}</span>
      }
    </div>
  </ng-template>
</p-dropdown>
